import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { DATE_FORMAT, MOBILE_WINDOW_BREAKPOINT } from '../../../../constants/constants';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import Icon from '../../../Common/Icon';
import { MultiSelect } from 'primereact/multiselect';
import { Checkbox } from 'primereact/checkbox';
import Moment from 'moment';
import { getDataTableSortFields } from '../../../../helpers/sortHelper';

export class ProjectLocationsTable extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            activeOptions: [
                { label: "Yes", value: true },
                { label: "No", value: false },
                { label: "All", value: null }
            ]
        };
    }

    componentDidMount() {
        // If columns haven't been defined yet, initialize them
        if (this.props.columns.length === 0) {
            this.props.setInitialColumns(this.initialColumns());
        }
    }

    initialColumns = () => {
        return [
            {
                isEnabled: this.displayColumns,
                field: "locationAbbreviation",
                header: "Abbreviation",
                sortable: true,
            },
            {
                isEnabled: true,
                field: "locationName",
                header: "Name",
                sortable: true,
            },
            {
                isEnabled: this.displayColumns,
                field: "zeroDate",
                header: "Zero Date",
                sortable: true,
                body: this.dateTemplate,
                style: { width: '100px' }
            },
            {
                isEnabled: this.displayColumns,
                field: "isPushedDown",
                header: "Pushed?",
                sortable: true,
                body: this.isPushedDownTemplate,
                style: { width: '76px' }
            },
            {
                isEnabled: this.displayColumns,
                field: "projectManager",
                header: "Project Implementation Manager",
                sortable: true,
            },
            {
                isEnabled: this.displayColumns,
                field: "baselines",
                header: "Baselines",
                body: this.baselineTemplate,
                sortable: false,
            },
            {
                isEnabled: true,
                field: "isOnHold",
                header: "On Hold?",
                sortable: true,
                body: this.isOnHoldTemplate,
                style: { width: '84px' }
            },
            {
                isEnabled: false,
                field: "isActive",
                header: "Active?",
                sortable: true,
                body: this.isActiveTemplate,
                style: { width: '80px' }
            },
            {
                isEnabled: false,
                field: "brandName",
                header: "Brand",
                sortable: true,
            },
            {
                isEnabled: false,
                field: "continentName",
                header: "Continent",
                sortable: true,
            },
            {
                isEnabled: false,
                field: "managementCompanyName",
                header: "Management Company",
                sortable: true,
            },
            {
                isEnabled: false,
                field: "areaName",
                header: "Area",
                sortable: true,
            },
            {
                isEnabled: false,
                field: "regionName",
                header: "Region",
                sortable: true,
            },
            {
                isEnabled: false,
                field: "typeName",
                header: "Type",
                sortable: true,
            },
            {
                isEnabled: false,
                field: "countryName",
                header: "Country",
                sortable: true,
            },
            {
                isEnabled: false,
                field: "generation",
                header: "Generation",
                sortable: true,
            }
        ]
    }

    displayColumns = (this.props.windowWidth < MOBILE_WINDOW_BREAKPOINT) ? false : true;

    rowOptions = () => {

        if (this.props.totalCount > 1000) {
            return [100, 250, 500, 1000, this.props.totalCount];
        }

        if (this.props.totalCount > 500) {
            return [100, 250, 500, this.props.totalCount];
        }

        if (this.props.totalCount > 250) {
            return [100, 250, this.props.totalCount];
        }

        if (this.props.totalCount > 100) {
            return [100, this.props.totalCount];
        }

        return [];
    }

    filterChange = (e) => {
        let name = e.target.name;
        this.props.updateSearchParams(name, e.target.value, false);
    }

    keyUpFilter = (e) => {
        if (e.keyCode == 13) {
            this.props.search();
        }
    }

    onPageChange = (e) => {
        this.props.onPageChange(e.rows, e.page + 1);
    }

    onSearchBlur = () => {
        this.props.search();
    }

    onMultiSelectChange = (name, value) => {
        this.props.updateSearchParams(name, value);
    }

    checkboxTemplate = (rowData) => {
        return <Checkbox name="checkbox" onChange={() => this.props.onToggleCheckedRow(rowData.id)} checked={rowData.isChecked}></Checkbox>
    }

    checkmarkTemplate = (isChecked) => {
        if (isChecked) {
            return <div className="text-success text-center"><Icon name="check-circle" /></div>;
        } else {
            return <div className="text-danger text-center"><Icon name="times-circle" /></div>;
        }
    }

    dateTemplate = (rowData) => {
        if (rowData.zeroDate) {
            return Moment.utc(rowData.zeroDate).format(DATE_FORMAT);
        } else {
            return null;
        }
    }

    isActiveTemplate = (rowData) => {
        return this.checkmarkTemplate(rowData.isActive);
    }

    isOnHoldTemplate = (rowData) => {
        return this.checkmarkTemplate(rowData.isOnHold);
    }

    isPushedDownTemplate = (rowData) => {
        return this.checkmarkTemplate(rowData.isPushedDown);
    }

    baselineTemplate = (rowData) => {
        if (!rowData.baselines || rowData.baselines.length === 0) {
            return <span>-</span>;
        }

        return rowData.baselines.map((baseline, index) => (
            <div key={index}>{baseline}</div>
        ));
    }

    renderColumns = () => {
        const filters = {
            areaName:
                <MultiSelect className="ui-column-filter" optionLabel="name"
                    value={this.props.searchParams.areas}
                    options={this.props.filters.areas}
                    onChange={(e) => this.onMultiSelectChange('areas', e.value)} />
            ,
            brandName:
                <MultiSelect className="ui-column-filter" optionLabel="name"
                    value={this.props.searchParams.brands}
                    options={this.props.filters.brands}
                    onChange={(e) => this.onMultiSelectChange('brands', e.value)} />
            ,
            continentName:
                <MultiSelect className="ui-column-filter" optionLabel="name"
                    value={this.props.searchParams.continents}
                    options={this.props.filters.continents}
                    onChange={(e) => this.onMultiSelectChange('continents', e.value)} />
            ,
            countryName:
                <MultiSelect className="ui-column-filter" optionLabel="name"
                    value={this.props.searchParams.countries}
                    options={this.props.filters.countries}
                    onChange={(e) => this.onMultiSelectChange('countries', e.value)} />
            ,
            generation:
                <input type="text" name="generation" className="p-inputtext" placeholder="Filter by Generation" onBlur={this.onSearchBlur} onChange={this.filterChange} onKeyUp={this.keyUpFilter} value={this.props.searchParams.generation} />
            ,
            isActive: <Dropdown name="isActive" className="ui-column-filter w-100"
                value={this.props.searchParams.isActive}
                options={this.state.activeOptions}
                onChange={(e) => this.onMultiSelectChange('isActive', e.value)}
            />,
            isOnHold: <Dropdown name="isOnHold" className="ui-column-filter w-100"
                value={this.props.searchParams.isOnHold}
                options={this.state.activeOptions}
                onChange={(e) => this.onMultiSelectChange('isOnHold', e.value)}
            />,
            isPushedDown: <Dropdown name="isPushedDown" className="ui-column-filter w-100"
                value={this.props.searchParams.isPushedDown}
                options={this.state.activeOptions}
                onChange={(e) => this.onMultiSelectChange('isPushedDown', e.value)}
            />,
            locationAbbreviation:
                <input
                    type="text"
                    name="locationAbbreviations"
                    className="p-inputtext"
                    placeholder="Filter by Abbreviation"
                    onBlur={this.onSearchBlur}
                    onChange={this.filterChange}
                    onKeyUp={this.keyUpFilter}
                    value={this.props.searchParams.locationAbbreviations} />
            ,
            locationName:
                <input type="text" name="locationName" className="p-inputtext" placeholder="Filter by Name" onBlur={this.onSearchBlur} onChange={this.filterChange} onKeyUp={this.keyUpFilter} value={this.props.searchParams.locationName} />
            ,
            managementCompanyName:
                <MultiSelect className="ui-column-filter" optionLabel="name"
                    value={this.props.searchParams.managementCompanies}
                    options={this.props.filters.managementCompanies}
                    onChange={(e) => this.onMultiSelectChange('managementCompanies', e.value)} />
            ,
            projectManager:
                <MultiSelect className="ui-column-filter" optionLabel="name"
                    value={this.props.searchParams.projectManagers}
                    options={this.props.filters.projectManagers}
                    onChange={(e) => this.onMultiSelectChange('projectManagers', e.value)} />
            ,
            baselines:
                <MultiSelect className="ui-column-filter" optionLabel="name"
                    value={this.props.searchParams.baselines}
                    options={this.props.filters.baselines}
                    onChange={(e) => this.onMultiSelectChange('baselines', e.value)} />
            ,
            regionName:
                <MultiSelect className="ui-column-filter" optionLabel="name"
                    value={this.props.searchParams.regions}
                    options={this.props.filters.regions}
                    onChange={(e) => this.onMultiSelectChange('regions', e.value)} />
            ,
            typeName:
                <MultiSelect className="ui-column-filter" optionLabel="name"
                    value={this.props.searchParams.types}
                    options={this.props.filters.types}
                    onChange={(e) => this.onMultiSelectChange('types', e.value)} />
            ,
            zeroDate:
                <MultiSelect className="ui-column-filter" optionLabel="name"
                    value={this.props.searchParams.zeroDates}
                    options={this.props.filters.zeroDates}
                    onChange={(e) => this.onMultiSelectChange('zeroDates', e.value)} />
        }

        let columns = this.props.columns.map((col) => {
            const filterElement = filters[col.field];
            if (filterElement && col.isEnabled) {
                return <Column key={col.field} field={col.field} sortable={col.sortable} filter={true} filterElement={filterElement} header={col.header} body={col.body} style={col.style} />;
            } else if (col.isEnabled) {
                return <Column key={col.field} field={col.field} sortable={col.sortable} header={col.header} body={col.body} style={col.style} />;
            } else {
                return null;
            }
        });

        return columns;
    }

    render() {
        const masterCheckbox = <div>
            <Checkbox name="checkbox" onChange={() => this.props.onMasterCheckboxToggle()} checked={this.props.allRowsChecked}></Checkbox>
        </div>;

        const { sortField, sortOrder } = getDataTableSortFields(this.props.searchParams);

        return (
            <Fragment>
                <DataTable
                    filterDisplay="row"
                    className="project-locations-table p-datatable-sm p-datatable-striped"
                    value={this.props.projectLocations}
                    selectionMode="single"
                    selection={this.props.selectedProjectLocation}
                    onSelectionChange={this.props.selectProjectLocation}
                    sortField={sortField}
                    sortOrder={sortOrder}
                    onSort={this.props.onSort}
                >
                    <Column className="checkbox-column" field="isChecked" filter={true} filterElement={masterCheckbox} body={this.checkboxTemplate} style={{ textAlign: 'center', width: '40px' }} />
                    {
                        this.renderColumns()
                    }
                </DataTable>
                {
                    this.props.totalCount > this.props.searchParams.pageSize &&
                    <Paginator
                        rows={this.props.searchParams.pageSize}
                        rowsPerPageOptions={this.rowOptions()}
                        totalRecords={this.props.totalCount}
                        first={(this.props.searchParams.pageNumber - 1) * this.props.searchParams.pageSize}
                        onPageChange={this.onPageChange} />
                }
                <div className="results-count">Total records: {this.props.totalCount}</div>
            </Fragment>
        );
    }

}

ProjectLocationsTable.propTypes = {
    allRowsChecked: PropTypes.bool.isRequired,
    columns: PropTypes.array.isRequired,
    filters: PropTypes.object.isRequired,
    isBulkEditModeEnabled: PropTypes.bool.isRequired,
    projectLocations: PropTypes.array.isRequired,
    searchParams: PropTypes.object.isRequired,
    selectedProjectLocation: PropTypes.object.isRequired,
    totalCount: PropTypes.number.isRequired,
    onMasterCheckboxToggle: PropTypes.func.isRequired,
    onSort: PropTypes.func.isRequired,
    onToggleCheckedRow: PropTypes.func.isRequired,
    search: PropTypes.func.isRequired,
    selectProjectLocation: PropTypes.func.isRequired,
    setInitialColumns: PropTypes.func.isRequired,
    updateSearchParams: PropTypes.func.isRequired,
    onPageChange: PropTypes.func.isRequired,
    windowWidth: PropTypes.number.isRequired
}

export default ProjectLocationsTable;
